import { ProcoList } from './procolist';
import { CheckItem } from './checkitem';

export class CheckList extends ProcoList {
  items = new Array<CheckItem>();
}